const MORIA_COMPONENTS = {
  REQUEST_DISPATCHER: 'RequestDispatcher',
  VERTICAL_FILTER: 'VerticalFilter',
  SORTING_BOX: 'SortingBox',
  JET_DELIVERY: 'JetDelivery',
  PRODUCTS_BANNER: 'ProductsBanner',
  HERO_FILTER: 'HeroFilter',
  SEARCH_RESULT_SUMMARY: 'SearchResultSummary',
  GOOGLE_VIDEO_ADX: 'GoogleVideoAdx',
  PRODUCT_LIST: 'ProductList',
  QUICK_FILTER: 'QuickFilter',
};

const MORIA_DESKTOP_PARTIALS_LIST = [
  MORIA_COMPONENTS.VERTICAL_FILTER,
  MORIA_COMPONENTS.SORTING_BOX,
  MORIA_COMPONENTS.JET_DELIVERY,
  MORIA_COMPONENTS.PRODUCTS_BANNER,
  MORIA_COMPONENTS.GOOGLE_VIDEO_ADX,
  MORIA_COMPONENTS.HERO_FILTER,
  MORIA_COMPONENTS.SEARCH_RESULT_SUMMARY,
  MORIA_COMPONENTS.PRODUCT_LIST
];

const MORIA_PASS_COOKIE_PREFIXES = [
  'dgr_',
  'hb_adult',
  'statsig_'
]

export {
  MORIA_COMPONENTS,
  MORIA_PASS_COOKIE_PREFIXES,
  MORIA_DESKTOP_PARTIALS_LIST
};
